module.exports = __webpack_public_path__ + "static/media/Тезисы УОМШ-22 (1 том).660c1a63.pdf";